import React from 'react';
import { motion } from 'framer-motion';
import type { TabId } from './customizerConfig';
import { TAB_CONFIG } from './customizerConfig';
import { THEME } from './theme';

interface CustomizationTabsProps {
  tabs: TabId[];
  activeTab: TabId;
  onChange: (tab: TabId) => void;
}

const CustomizationTabs: React.FC<CustomizationTabsProps> = ({ tabs, activeTab, onChange }) => {
  return (
    <div className="w-full">
      <div
        className="flex w-full items-center rounded-full p-1"
        style={{ background: 'rgba(255,255,255,0.04)', border: `1px solid ${THEME.border}` }}
      >
        {tabs.map((tabId) => {
          const config = TAB_CONFIG[tabId];
          const isActive = activeTab === tabId;

          return (
            <button
              key={tabId}
              onClick={() => onChange(tabId)}
              className="relative flex-1 py-2.5 rounded-full text-[11px] font-bold uppercase tracking-[0.15em] cursor-pointer whitespace-nowrap z-10 transition-all duration-200 text-center hover:bg-white/[0.04]"
              style={{ color: isActive ? '#fff' : 'rgba(255,255,255,0.35)' }}
            >
              {isActive && (
                <motion.div
                  layoutId="mainTabPill"
                  className="absolute inset-0 rounded-full"
                  style={{ background: THEME.primary, boxShadow: THEME.primaryGlow }}
                  transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                />
              )}
              <span className="relative z-10">{config.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CustomizationTabs;
